/*
 * @Author: he.zhikai
 * @Date: 2018-04-16
 * @LastEditTime: 2021-09-30 16:59:48
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\components\util\trsWordCountTextarea\trsWordCountTextarea.js
 * @Description: 带字数统计的文本域
 */
'use strict';
angular.module('util.trsWordCountTextarea', ['util.trsWordCountTextareaSlot']).directive('trsWordCountTextarea', [function () {
    return {
        restrict: 'E',
        scope: {
            model: '=', // textarea框模型
            name: '@', // textarea框name
            validate: '@', // textarea框表单校验项
            wordCount: '@', // 字数统计
            maxLengthMessage: '@', // 表单校验长度项提示
            form: '=', // 表单name
            placeHolder: '@' // textarea框提示信息
        },
        templateUrl: './components/util/trsWordCountTextarea/trsWordCountTextarea_tpl.html',
        replace: true,
        link: function (scope, iElement, iAttrs) {
            init();

            /**
			 * [init description] 初始化
			 * @return {[type]} [description]
			 */
            function init() {
                // textarea聚焦外层div高亮，textarea失焦外层div不亮
                iElement.find('textarea').bind('focus', function () {
                    iElement.addClass('focus');
                }).bind('blur', function () {
                    iElement.removeClass('focus');
                });
            }
        }
    };
}]);
